import { IconProps } from '../icon-props-interface';
import '../icons.scss';

export const IconCreditCard = ({ color = 'var(--color-accent-1)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="32" height="32" viewBox="0 3 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 17C9 15.8954 9.89543 15 11 15H22C23.1046 15 24 15.8954 24 17V22C24 23.1046 23.1046 24 22 24H11C9.89543 24 9 23.1046 9 22V17Z" stroke="#2F3467" strokeWidth="1.3"/>
            <path d="M21 15L22.3015 14.2213C23.1848 13.6927 23.5227 12.58 23.0824 11.6495L21.3206 7.92644C20.8508 6.93359 19.6682 6.50544 18.6716 6.96741L9.8764 11.0447C8.91002 11.4927 8.46432 12.6195 8.86276 13.6073L9.49938 15.1857" stroke="#2F3467" strokeWidth="1.3" strokeLinecap="round"/>
            <path d="M9 18L23.5 18" stroke="#2F3467" strokeWidth="1.3"/>
        </svg>
    </div>
);

export default IconCreditCard;
